import { api } from 'api/client';
import { User, RegisterRequest, UserRole } from 'types/user.types';
import { ListResponse, SuccessResponse } from 'types/api.types';

export const usersApi = {
  list: async (
    limit: number = 20,
    offset: number = 0,
    role?: UserRole
  ): Promise<ListResponse<User>> => {
    const response = await api.get<ListResponse<User>>(
      '/users',
      { limit, offset, role }
    );
    return response.data;
  },

  get: async (id: number): Promise<User> => {
    const response = await api.get<User>(`/users/${id}`);
    return response.data;
  },

  create: async (data: RegisterRequest): Promise<SuccessResponse & { user: User }> => {
    const response = await api.post<SuccessResponse & { user: User }>(
      '/auth/register',
      data
    );
    return response.data;
  },

  update: async (id: number, data: Partial<User>): Promise<SuccessResponse & { user: User }> => {
    const response = await api.put<SuccessResponse & { user: User }>(
      `/users/${id}`,
      data
    );
    return response.data;
  },

  delete: async (id: number): Promise<SuccessResponse> => {
    const response = await api.delete<SuccessResponse>(`/users/${id}`);
    return response.data;
  },

  changeRole: async (id: number, role: UserRole, buyerId?: string): Promise<SuccessResponse> => {
    const response = await api.patch<SuccessResponse>(
      `/users/${id}/role`,
      { role, buyer_id: buyerId }
    );
    return response.data;
  },

  resetUserPassword: async (id: number): Promise<SuccessResponse & { temp_password: string }> => {
    const response = await api.post<SuccessResponse & { temp_password: string }>(
      `/users/${id}/reset-password`
    );
    return response.data;
  },

  getUserApplications: async (id: number): Promise<any[]> => {
    const response = await api.get<any[]>(`/users/${id}/applications`);
    return response.data;
  },

  setSegments: async (userId: number, segmentIds: number[]): Promise<void> => {
    await api.post(`/users/${userId}/segments`, { segment_ids: segmentIds });
  },
};